<template>
  <div class="clearfix">
    <AUpload
      :disabled="disabled"
      :action="url"
      :headers="headers"
      :accept="accept"
      list-type="picture-card"
      :multiple="false"
      :data="getData"
      :file-list="fileList"
      @preview="handlePreview"
      @select="select"
      @beforeUpload="beforeUpload"
      @change="handleChange"
      :remove="handleRemove"
    >
      <div v-if="fileList.length < 8">
        <a-icon type="plus"/>
        <div class="ant-upload-text">
          {{ title || label }}
        </div>
      </div>
    </AUpload>
    <AModal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage"/>
    </AModal>
    <AFormItem ref="fi">
      <input v-decorator="[field]" type="hidden"/>
    </AFormItem>
  </div>
</template>
<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

//import themeConfig from "../../../../themeConfig";

export default {
  name: 'UploadInput',
  props: {
    title: {},
    label: {},
    field: {},
    size: {
      default: 2
    },
    disabled: {
      required:false,
      type:Boolean,
      default: false
    },
    accept: {default: "image/jpeg"},
    serverType: {
      types: {
        1: 'عکس',
        2: 'فیلم',
        3: 'مدارک',
        4: 'صوت',
        5: 'pdf',
      }
    },
  },
  data() {
    return {
      url: 'http://hr.asco-intl.com:2020/kernel/api/register/upload',
      previewVisible: false,
      previewImage: '',
      fileList: [],
    };
  },
  watch: {
    fileList(n, o) {
      if (n.length > o.length) {
        this.$emit('add-file', n);
      } else if (n.length < o.length) {
        this.$emit('remove-file', n);
      }
    }
  },
  methods: {
    handleRemove(){
      const a = {};
      a[`${this.field}`] =null
      this.$refs.fi.FormContext.form.setFieldsValue(a)
    },
    beforeUpload(file) {
      const isJpgOrPng = this.types.includes(file.type);
      if (!isJpgOrPng) {
        this.$message.error('تنها مجاز به ارسال تصویر با پسوند jpg هستید.');
      }
      const isLt2M = file.size / 1024 / 1024 < this.size;
      if (!isLt2M) {
        this.$message.error(`فایل بارگذاری شده بیش از ${this.size} مگا بایت نباید باشد.`);
      }
      return isJpgOrPng && isLt2M;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({fileList, event, file}) {
      if (fileList.length > 1) {
        this.$message.error('تنها یک فایل در این قست قابل بارگذاری می باشد.');
        return false;
      }
      if (file.response && file.response.id) {
        this.$emit('ok', file.response);
        const a = {};
        a[`${this.field}`] = file.response.id
        this.$refs.fi.FormContext.form.setFieldsValue(a)
      }
      this.fileList = fileList;
    },
    select() {
      console.log("555 ==> ", 555);
    },
    getData() {
      return {
        has_thumb: 1,
        has_watermark: 1,
        type: this.serverType || 1,
        subject: 1,
        title: 1
      }
    }
  }
  ,
  computed: {
    headers() {
      return {
        'Authorization': 'Bearer ' + localStorage.getItem("accessToken") || localStorage.accessToken
      }
    }
  }
}
;
</script>
<style>
/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
